import React, { useState } from 'react';
import classes from './faq.module.css';
import Avatar from '../../../assets/images/aws_dynamoDb/Avatar.png';
import Avatar2 from '../../../assets/images/aws_dynamoDb/Avatar1.png';
import Avatar3 from '../../../assets/images/aws_dynamoDb/Avatar2.png';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { FAQ } from './questions';
import { Link } from 'react-router-dom';

const FaqPage = () => {
    const [dropdown, setDropdown] = useState([]);

    const handleOpen = (id) => {
        if (dropdown.includes(id)) {
            setDropdown(dropdown.filter((item) => item !== id));
        } else {
            setDropdown([...dropdown, id]);
        }
    };

    return (
        <section className={classes['faq-section']}>
            <h2>Frequently asked questions</h2>

            {FAQ.map((fa) => (
                <div
                    key={fa.id}
                    className={classes['faq']}
                >
                    <section>
                        <h4>{fa.question}</h4>

                        {dropdown.includes(fa.id) ? (
                            <AiOutlineMinusCircle
                                id={classes['icon']}
                                onClick={() => handleOpen(fa.id)}
                            />
                        ) : (
                            <AiOutlinePlusCircle
                                id={classes['icon']}
                                onClick={() => handleOpen(fa.id)}
                            />
                        )}
                    </section>
                    {dropdown.includes(fa.id) && <p>{fa.answer}</p>}
                </div>
            ))}

            <section className={classes['faq-avatars']}>
                <img
                    src={Avatar}
                    alt="iLearnCloud"
                />
                <img
                    src={Avatar2}
                    alt="iLearnCloud"
                />
                <img
                    src={Avatar3}
                    alt="iLearnCloud"
                />
            </section>

            <h4 id={classes['faq-h2']}>
                Let's redefine your cloud experience together!
            </h4>
            <p id={classes['faq-p']}>
                Your journey to an efficient, secure, and optimized cloud
                resource management with AWS Systems Manager
            </p>
            <Link
                to="/contact"
                style={{ textDecoration: 'none' }}
            >
                <button>Get in touch</button>
            </Link>
        </section>
    );
};

export default FaqPage;
